/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { createCampaignDataStatusSchema } from './CreateCampaignDataStatusSchema'

export const createCampaignDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	title: z.string().nullable().optional(),
	language: z.string(),
	requirements: z.string().nullable().optional(),
	notes: z.string().nullable().optional(),
	status: createCampaignDataStatusSchema.nullable().optional(),
	budget: z.number().nullable().optional(),
	organisationId: z.string().uuid(),
	formId: z.string().uuid().nullable().optional(),
	location: z.string(),
	audience: z.string().nullable().optional(),
	branding: z.object({
		id: z.string().nullable().optional(),
		organisationId: z.string().nullable().optional(),
		name: z.string().nullable().optional(),
		website: z.string().nullable().optional(),
		logoId: z.string().nullable().optional(),
		logo: z.object({
			id: z.string(),
			name: z.string(),
			fileName: z.string(),
			category: z.union([z.literal('image'), z.literal('file')]),
			mimeType: z.string().nullable().optional(),
			size: z.number(),
			humanReadableSize: z.string(),
			imgix_url: z.string(),
			collectionName: z.union([
				z.literal('ad-asset'),
				z.literal('baked-story'),
				z.literal('baked-feed'),
				z.literal('story'),
				z.literal('feed'),
				z.literal('landing-page'),
				z.literal('logo'),
				z.literal('generated'),
				z.literal('uploaded'),
				z.literal('imported'),
				z.literal('candidate-files'),
				z.literal('custom-font'),
				z.literal('design'),
				z.literal('whatsapp-profile'),
			]),
			width: z.number(),
			height: z.number(),
			isPlaceholder: z.boolean(),
			isGenerating: z.boolean(),
			createdAt: z.iso.datetime(),
			isGenerated: z.boolean().optional().default(false),
			startedGenerationAt: z.iso.datetime().nullable().optional(),
			finishedGenerationAt: z.iso.datetime().nullable().optional(),
			meta: z.record(z.string(), z.unknown()).nullable().optional(),
		}).nullable().optional(),
		toneOfVoice: z.string().nullable().optional(),
		visualGuidance: z.string().nullable().optional(),
		cornerRadius: z.string().nullable().optional(),
		background: z.string(),
		foreground: z.string(),
		accentBackground: z.string(),
		accentForeground: z.string(),
		fonts: z.object({ title: z.string().nullable(), body: z.string().nullable() }).optional(),
		createdAt: z.iso.datetime().nullable().optional(),
		updatedAt: z.iso.datetime().nullable().optional(),
		isGenerated: z.boolean().optional().default(false),
		startedGenerationAt: z.iso.datetime().nullable().optional(),
		finishedGenerationAt: z.iso.datetime().nullable().optional(),
		meta: z.record(z.string(), z.unknown()).nullable().optional(),
		generateKeyImage: z.boolean().optional().default(true),
		generationError: z.union([z.literal('website_unreachable'), z.literal('scan_failed')]).nullable().optional(),
	}).nullable().optional(),
	brandingId: z.string().uuid().nullable().optional(),
	generateKeyImage: z.boolean().nullable().optional(),
	sourceWebsite: z.string().nullable().optional(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
	adCampaignLocations: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			country: z.object({ id: z.string(), name: z.string() }),
			region: z.object({ id: z.string().optional(), name: z.string().optional() }).nullable(),
			radius: z.number().optional(),
		}),
	).nullable().optional(),
	startDate: z.iso.datetime().nullable().optional(),
	endDate: z.iso.datetime().nullable().optional(),
})

export type CreateCampaignDataSchema = z.infer<typeof createCampaignDataSchema>
